<template>
    <div>
      <b-modal
        hide-footer
        centered
        :size=" !modalConfimarSemAdiantamento ? 'xl' : 'lg'"
        ref="add-travel-modal"
        id="add-travel-modal"
        :hide-header="modalConfimarSemAdiantamento"
        title="Adicionar novo documento">
        <template #modal-header v-if="!modalConfimarSemAdiantamento">
            <div class="head-modal">
                <p id="title-modal-cus">SOLICITAR AUTORIZAÇÃO PARA REEMBOLSO DE VIAGEM</p>
            </div>
            <button id="btn-cancel" @click="close()">X</button>
        </template>
          <div class="w-100">
            <div v-if="!modalConfimarSemAdiantamento" class="d-flex justify-content-center">
                <div class="d-flex justify-content-center w-100">
                  <div class="body-status">
                    <div class="one-status" @click="backStep(0)"><div  :class="step === 0  ? 'cicle-status' : step > 0 ? 'cicle-status-after' : ''"><i class="fas fa-info"></i></div><p class="inf-status-one">Informações</p></div>
                    <div class="one-status" v-if="passFly" @click="backStep(1)"><div  :class="step === 1  ? 'cicle-status' : step > 1 ? 'cicle-status-after' : ''"><i class="fas fa-plane"></i></div><p class="inf-status-one">Viagem Aérea</p></div>
                    <div class="regua-status">
                      <div class="regua-prog" :style="'width:' + widthPogress + '%'"></div>
                    </div>
                    <div @click="backStep(2)" class="one-status"><div :class="step === 2  ? 'cicle-status' : step > 2 ? 'cicle-status-after' : 'cicle-status-before'"><i class="fas fa-dollar-sign"></i></div><p class="inf-status-one">Previsão de gastos</p></div>
                    <div @click="backStep(3)" class="one-status"><div :class="step === 3  ? 'cicle-status' : step > 3 ? 'cicle-status-after' : 'cicle-status-before'"><i class="fas fa-file"></i></div><p class="inf-status-one">Termo</p></div>
                    <div @click="backStep(4)" class="one-status"><div :class="step === 4  ? 'cicle-status' : step > 4 ? 'cicle-status-after' : 'cicle-status-before'"><i class="fas fa-signature"></i></div><p class="inf-status-one  ">Assinatura</p></div>
                  </div>

                </div>
            </div>
            <InfoModalTravel @semAdiantamento="SemAdiantamentoVerifica" @onLoad="onLoad" ref="InfoModalTravel" v-if="step == 0 && !modalConfimarSemAdiantamento"></InfoModalTravel>
            <TravelAirPlaneModal @eventAir="eventAir" ref="TravelAirPlaneModal" v-if="step == 1 && !modalConfimarSemAdiantamento"></TravelAirPlaneModal>
            <PredictionModal :motivoViagemId="motivoViagemId" @quantidadeVazio="quantidadeVazio" @onLoadThird="onLoadThird" ref="PredictionModal" v-if="step == 2 && !modalConfimarSemAdiantamento"></PredictionModal>
            <TermTravekModal :dataobj="formFirst" :motivoViagemId="motivoViagemId" ref="TermTravekModal" :total="total" :dataPerson="personFirst" v-if="step == 3 && !modalConfimarSemAdiantamento"></TermTravekModal>
            <SingModal ref="SingModal" :total="total" :dataobj="formFirst" v-if="step == 4"></SingModal>
            <ModalConfimarSemAdiantamento v-if="modalConfimarSemAdiantamento"></ModalConfimarSemAdiantamento>
            <div v-if="!modalConfimarSemAdiantamento" class="d-flex justify-content-center mt-5">
                <button  @click="backStep(step - 1)" v-if="step !== 0 " id="btn-adicionar" class="botoesPopUp mr-2"> VOLTAR </button>
                <button  @click="close()" v-else id="btn-adicionar" class="botoesPopUp mr-2"> CANCELAR </button>
                <button v-if="!semAdiantamentos" @click="nextStep"  v-bind:style= "[ {'backgroundColor': '#008148', 'color':'#FFFFFF'}]" ref="btn_avancar" class="botoesPopUp ml-2" >AVANÇAR</button>
                <button v-if="semAdiantamentos" @click="nextStep"  v-bind:style= "[ {'backgroundColor': '#008148', 'color':'#FFFFFF'}]" ref="btn_avancar" class="botoesPopUp ml-2" >CONCLUIR</button>
            </div>
            <div v-else class="d-flex justify-content-center mt-5">
                <button  @click="voltarConfirma"  id="btn-adicionar" class="botoesPopUp mr-2"> VOLTAR </button>
                <button @click="createTerm"  v-bind:style= "[ {'backgroundColor': '#008148', 'color':'#FFFFFF'}]" ref="btn_avancar" class="botoesPopUp ml-2" >AVANÇAR </button>
            </div>
          </div>
        </b-modal>

        <b-modal
        hide-footer
        centered
        size="md"
        ref="add-travel-modal-erro"
        id="add-travel-modal-erro"
        title="Funcionário Impossibilitado de Gerar Reembolso Temporariamente">
        <!-- <template #modal-header>
            <div class="head-modal-error">
                <p id="title-modal-cus" class="erroPoUp">Funcionário Impossibilitado de Gerar Reembolso Temporariamente</p>
            </div>
        </template> -->
          <div v-if="ArrayFuncionarioImpossibilitado !== 0">
            <div v-if="ArrayFuncionarioImpossibilitado.despesa != null">
              <div class="corpofluxo" v-if="ArrayFuncionarioImpossibilitado.despesa[0].fluxo == 'Reembolso Viagem - Prestação de Conta'">
                   <div class="fluxo_corpo">
                      <div class="fluxo_label_fluxo">
                          {{ArrayFuncionarioImpossibilitado.despesa[0].fluxo}}
                      </div>
                  </div>
                  <div class="fluxo_corpo">
                      <div class="fluxo_icone">
                          <i class="fa fa-user-circle" aria-hidden="true"></i>
                      </div>
                      <div class="fluxo_label">
                          Funcionário: {{ArrayFuncionarioImpossibilitado.despesa[0].codigo}} - {{ArrayFuncionarioImpossibilitado.despesa[0].nomeFuncionario}}
                      </div>
                  </div>

                  <div class="fluxo_corpo">
                      <div class="fluxo_icone">
                          <i class="fas fa-money-check" aria-hidden="true"></i>
                      </div>
                      <div class="fluxo_label">
                           Valor: {{formatMoney(ArrayFuncionarioImpossibilitado.despesa[0].valorGasto)}}
                      </div>
                  </div>
              </div>
            </div>
            <div v-if="ArrayFuncionarioImpossibilitado.termoAceite != null">
              <div class="corpofluxo"  v-if="ArrayFuncionarioImpossibilitado.termoAceite[0].fluxo == 'Reembolso Viagem - Adiantamento'">
                  <div class="fluxo_corpo" >
                      <div class="fluxo_label_fluxo">
                           {{ArrayFuncionarioImpossibilitado.termoAceite[0].fluxo}}
                      </div>
                  </div>

                  <div class="fluxo_corpo">
                      <div class="fluxo_icone">
                          <i class="fa fa-user-circle" aria-hidden="true"></i>
                      </div>
                      <div class="fluxo_label">
                           Funcionário: {{ArrayFuncionarioImpossibilitado.termoAceite[0].codigo}} - {{ArrayFuncionarioImpossibilitado.termoAceite[0].nomeFuncionario}}
                      </div>
                  </div>

                  <div class="fluxo_corpo">
                      <div class="fluxo_icone">
                         <i class="fas fa-money-check" aria-hidden="true"></i>
                      </div>
                      <div class="fluxo_label">
                          Valor: {{formatMoney(ArrayFuncionarioImpossibilitado.termoAceite[0].valorGasto)}}
                      </div>
                  </div>
              </div>
            </div>
             <div v-if="ArrayFuncionarioImpossibilitado.despesasDiversos != null">
              <div class="corpofluxo" v-if="ArrayFuncionarioImpossibilitado.despesasDiversos[0].fluxo == 'Despesas Diversos'">
                  <div class="fluxo_corpo">
                      <div class="fluxo_label_fluxo">
                          {{ArrayFuncionarioImpossibilitado.despesasDiversos[0].fluxo}}
                      </div>
                  </div>

                  <div class="fluxo_corpo">
                      <div class="fluxo_icone">
                         <i class="fa fa-user-circle" aria-hidden="true"></i>
                      </div>
                      <div class="fluxo_label">
                         Funcionário:{{ArrayFuncionarioImpossibilitado.despesasDiversos[0].codigo}} - {{ArrayFuncionarioImpossibilitado.despesasDiversos[0].nomeFuncionario}}
                      </div>
                  </div>

                  <div class="fluxo_corpo">
                      <div class="fluxo_icone">
                          <i class="fa fa-money-check" aria-hidden="true"></i>
                      </div>
                      <div class="fluxo_label">
                          Valor: {{formatMoney(ArrayFuncionarioImpossibilitado.despesasDiversos[0].valorGasto)}}
                      </div>
                  </div>
              </div>
            </div>
            <div v-if="ArrayFuncionarioImpossibilitado.despesasViagem != null">
              <div class="corpofluxo" v-if="ArrayFuncionarioImpossibilitado.despesasViagem[0].fluxo == 'Despesas Viagem'">
                  <div class="fluxo_corpo">
                      <div class="fluxo_label_fluxo">
                          {{ArrayFuncionarioImpossibilitado.despesasViagem[0].fluxo}}
                      </div>
                  </div>

                  <div class="fluxo_corpo">
                      <div class="fluxo_icone">
                          <i class="fa fa-user-circle" aria-hidden="true"></i>
                      </div>
                      <div class="fluxo_label">
                         Funcionário: {{ArrayFuncionarioImpossibilitado.despesasViagem[0].nomeFuncionario}}
                      </div>
                  </div>

                  <div class="fluxo_corpo">
                     <div class="fluxo_icone">
                          <i class="fa fa-money-check" aria-hidden="true"></i>
                      </div>
                      <div class="fluxo_label">
                          Valor: {{formatMoney(ArrayFuncionarioImpossibilitado.despesasViagem[0].valorGasto)}}
                      </div>
                  </div>
              </div>
            </div>

            <div v-if="ArrayFuncionarioImpossibilitado.motivoDesligado != null">
              <div class="corpofluxo" v-if="ArrayFuncionarioImpossibilitado.motivoDesligado[0].fluxo == 'Motivo Viagem Desligado'">
                  <div class="fluxo_corpo">
                      <div class="fluxo_label_fluxo">
                          {{ArrayFuncionarioImpossibilitado.motivoDesligado[0].fluxo}}
                      </div>
                  </div>

                  <div class="fluxo_corpo">
                      <div class="fluxo_icone">
                          <i class="fa fa-user-circle" aria-hidden="true"></i>
                      </div>
                      <div class="fluxo_label">
                         Funcionário: {{ArrayFuncionarioImpossibilitado.motivoDesligado[0].nomeFuncionario}}
                      </div>
                  </div>

                  <div class="fluxo_corpo">
                     <div class="fluxo_icone">
                          <i class="fa fa-money-check" aria-hidden="true"></i>
                      </div>
                      <div class="fluxo_label">
                          Valor: {{formatMoney(ArrayFuncionarioImpossibilitado.motivoDesligado[0].valorGasto == null ? 0 : ArrayFuncionarioImpossibilitado.motivoDesligado[0].valorGasto )}}
                      </div>
                  </div>
              </div>
            </div>

            <div v-if="ArrayFuncionarioImpossibilitado.adiantamentoIdentico != null">
              <div class="" v-if="ArrayFuncionarioImpossibilitado.adiantamentoIdentico[0].fluxo == 'Adiatamento Aprovado'">
              <div class="fluxo_corpo_aviso">
                  <div class="fluxo_icone_menssagem">
                     <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                  </div>
                  <div class="fluxo_label_menssagem">
                      Funcionário já possui uma solicitação registrada no mesmo período e mesmo Motivo Viagem.
                  </div>
              </div>

              <div class="fluxo_corpo_identico">
                  <div class="fluxo_label">
                    <div class="label_numero_solicitado">Número da Solicitação</div>
                    <div class="label_numero_solicitado_info">{{ArrayFuncionarioImpossibilitado.adiantamentoIdentico[0].numeroSolicitado == null ? 'N/D' : ArrayFuncionarioImpossibilitado.adiantamentoIdentico[0].numeroSolicitado}}</div>
                  </div>
              </div>

              </div>

            </div>
              <div class="fluxo_corpo_aviso" v-if="ArrayFuncionarioImpossibilitado.adiantamentoIdentico == null">
                  <div class="fluxo_icone_menssagem">
                     <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                  </div>
                  <div class="fluxo_label_menssagem">
                      Por favor regularize a situação do funcionário para criar novos reembolsos!
                  </div>
              </div>
          </div>
          <div else></div>
        </b-modal>
    </div>
</template>

<script>
import ModaAddTravelAdvance from './ModaAddTravelAdvance'
export default ModaAddTravelAdvance
</script>

<style scoped>
.fluxo_corpo_identico{
    margin-top: 1rem;
    padding: 1rem;
    align-items: center;
    display: flex;
    justify-content: center;
    gap: 1rem;
    border-radius: 2px;
    background-color: #025e33;
  }
  .label_numero_solicitado{
    width: 100%;
    font-size: 15px;
    font-weight: bold;
    color: #f5f5f5;
   }
  .head-modal-error{
    display: flex;
    justify-content: center;
  }
  .erroPoUp {
    color: white !important;
    font-size: 16px !important;
    line-height: 1.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .corpofluxo{
    padding: 1rem;
    display: flex;
    background: #dddddd73;
    border-radius: 11px;
    margin-bottom: 1rem;
    gap: 1rem;
    flex-direction: column;
  }
  .fluxo_label_menssagem{
    font-size: 15px;
    font-weight: bold;
  }
  .fluxo_label_Identinco {
    width: 40%;
    border-right: solid #046437 2px;
    text-align: justify;
    font-weight: bold;
    padding-right: 0.5rem;
    font-size: 13px;
  }
  .label_numero_solicitado_info{
    padding-top: 10px;
    font-size: 25px;
    text-align: center;
    color: #FFFF00;
  }

  .fluxo_label{
    font-size: 15px;
  }
  .icone-identico{
    font-size: 34px;
    color: #fcfefd ;
  }
  .fluxo_label_fluxo{
  font-size: 15px;
  font-weight: bold;
  color: #046437
  }

  .fluxo_icone_menssagem{
    font-size: 25px;
    color: #046437
  }
  .fluxo_icone{
    font-size: 20px;
    width: 2rem;
    color: #046437
  }
  .fluxo_corpo_aviso{
    padding: 1rem;
    align-items: center;
    display: flex;
    justify-content: initial;
    gap: 1rem;
    border: 2px dashed #046437;
  }

  .fluxo_corpo{
    align-items: center;
    display: flex;
    justify-content: initial;
    gap: 1rem;
  }

  .cicle-status{
    height: 60px;
    width: 60px;
    z-index: 5;
    display: flex;
    justify-content: center;
    box-shadow: 1px 2px #707070;
    align-items: center;
    background: white;
    color:#025e33;
    font-size: 23px;
    border-radius: 50%;
  }
  .regua-prog{
    background: #025e33;
    height: 100%;
  }
  .cicle-status-after{
    height: 60px;
    width: 60px;
    z-index: 5;
    display: flex;
    cursor: pointer;
    justify-content: center;
    align-items: center;
    background: #025e33;;
    color: white;
    font-size: 23px;
    border-radius: 50%;
  }
  .cicle-status-before{
    height: 60px;
    width: 60px;
    z-index: 5;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgb(226, 225, 225);
    color: white;
    font-size: 23px;
    border-radius: 50%;
  }
  .body-status{
    display: flex;
    position: relative;
    width: 60%;
    justify-content: space-between;
    align-items: center;
  }
  .one-status{
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    z-index: 6;
  }
 .head-modal{
    display: flex;
    justify-content: center;
    width: 100%;
 }
 #title-modal-cus{
    color: white;
    font-size: 25px;
    font-weight: bold;
 }
 .modal-header{
    padding: 0 !important;
 }
 .inf-status-one{
  font-weight:bold;
  margin-top: 5px;
 }
 .botoesPopUp{
    width: 251px;
    height: 41px;
    background: #DEDEDE 0% 0% no-repeat padding-box;
    border-radius: 4px;
    border-style: none;
}
.switch-cus{
    width: 300px;
}
 #btn-cancel{
    position: absolute;
    right: 10px;
    top: 10px;
    font-weight: bold;
    border: none;
    color: #025e33;
    width: 35px;
    font-size: 16px;
    height: 35px;
    border-radius: 50%;
 }
 .switchbtn{
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: white;
 }
 .info-pogress{
    margin-top: 10px;
 }
 .input-change{
    width: 75px;
    height: 35px;
    background: blue;
    border-radius: 48%;
 }
 .status-progress{
    height: 55px;
    width: 55px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    font-size: 16px;
    align-items: center;
    box-shadow: 1px 2px #888888;
    color: #025e33;
    background-color: white;
 }
 .row-pogress{
    width: 7%;
    height: 10px;
    margin-left: 1px;
    background: rgb(226, 225, 225);
    border-radius: 5px;

 }
 .info-status{
    color: #025e33;
    font-weight: bold;
 }
 .label-search{
    padding-bottom: 0px;
    margin-bottom: 0px;
    margin-top: 10px;
    font-weight: bold;
  }
  .regua-status{
    width: 92%;
    height: 18px;
    left: 55px;
    top: 25px;
    border-radius: 8px;
    position: absolute;
    background: rgb(226, 225, 225);
  }
</style>



// WEBPACK FOOTER //
// src/views/private/travelreimbursement/components/ModaAddTravelAdvance/ModaAddTravelAdvance.vue